/**
 * 用料需求料號首碼（mtr.mtrNo 第一碼大寫）。
 */
export function getMtrNoPrefix(mtrNo) {
  const first = String(mtrNo ?? '').trim().charAt(0);
  return first ? first.toUpperCase() : '';
}

/** A／B → 建立工單（採購勾選另見：全部列皆可） */
export function isWorkOrderCreatePrefix(prefix) {
  return prefix === 'A' || prefix === 'B';
}

/** 列 key：優先 mtr.id，否則 mtrNo-index */
export function resolveRequirementRowKey(row, index) {
  const mtrId = row?.mtr?.id;
  if (mtrId != null && mtrId !== '') {
    return String(mtrId);
  }
  const mtrNo = row?.mtr?.mtrNo;
  if (mtrNo) {
    return `${mtrNo}-${index}`;
  }
  return `material-req-${index}`;
}

/** 是否有短缺量（shortageQty > 0）；採購預設只針對短缺料。 */
export function hasRequirementShortage(row) {
  const qty = Number(row?.shortageQty);
  return Number.isFinite(qty) && qty > 0;
}
